import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useBannersData } from "@faire/retailer-visitor-shared/components/Banners/DataFetching/__internal__/useBannersData";
import { SearchResultsBanner } from "@faire/retailer-visitor-shared/components/Banners/SearchBanners/SearchResultsBanner";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageBannersDataContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageBannersDataContext";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useMemo } from "react";
var common = {
    type: SearchResultsBanner.CATEGORY_LINKING_BANNER,
    size: 2,
    rowNumberRelativeToProductRow: true
};
var responsiveBannerDisplayData = {
    mobileAndAbove: _object_spread_props(_object_spread({}, common), {
        row: 9,
        column: 1,
        fullRowBanner: true
    }),
    tabletAndAbove: _object_spread_props(_object_spread({}, common), {
        row: 6,
        column: 3,
        fullRowBanner: false
    }),
    desktopAndAbove: _object_spread_props(_object_spread({}, common), {
        row: 6,
        column: 4,
        fullRowBanner: false
    })
};
export var useSearchPageBannersResponse = function(bannersResponse) {
    var responsiveData = useResponsiveValue(responsiveBannerDisplayData);
    var _ref = bannersResponse !== null && bannersResponse !== void 0 ? bannersResponse : {}, category_pills_response = _ref.category_pills_response, sign_up_product_grid_banner = _ref.sign_up_product_grid_banner;
    var isDiscoverPage = useSearchPageIsFromDiscoverURL();
    var eligibleBannersDisplayDataInPriorityOrder = useMemo(function() {
        var data = [];
        if (sign_up_product_grid_banner) {
            // This banner is logged-out only and so we do not need to worry about
            // its position relative to other logged-in only banners.
            if (isDiscoverPage) {
                data.push({
                    type: SearchResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
                    row: 6,
                    fullRowBanner: true,
                    size: 0,
                    column: 1
                });
            } else {
                data.push({
                    type: SearchResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
                    column: 1,
                    row: 3,
                    size: 2
                });
            }
        }
        if (category_pills_response !== undefined && (category_pills_response === null || category_pills_response === void 0 ? void 0 : category_pills_response.category_pills.length) > 0) {
            data.push(responsiveData);
        }
        return data;
    }, [
        category_pills_response,
        responsiveData,
        sign_up_product_grid_banner,
        isDiscoverPage
    ]);
    var _useBannersData = useBannersData(eligibleBannersDisplayDataInPriorityOrder), replacedProductTilesCount = _useBannersData.replacedProductTilesCount, displayableBannersWithAdjustedRow = _useBannersData.displayableBannersWithAdjustedRow;
    return useMemo(function() {
        return {
            bannersResponse: bannersResponse,
            bannersDisplayData: eligibleBannersDisplayDataInPriorityOrder,
            replacedProductTilesCount: replacedProductTilesCount,
            displayableBannersWithAdjustedRow: displayableBannersWithAdjustedRow
        };
    }, [
        bannersResponse,
        eligibleBannersDisplayDataInPriorityOrder,
        replacedProductTilesCount,
        displayableBannersWithAdjustedRow
    ]);
};
export var useSearchPageBannersData = function() {
    return useSearchPageBannersDataContext();
};
